import * as React from "react";
import { IRouter } from "../../../runtime/Router";
import { TTranslate } from "../../service/locale/TranslationService";
import { IUser } from "../../../user/model/User";
import { IOrganisation } from "../../../organisations/model/Organisation";
import { Row, Col } from "antd";

export interface PageProps {
  router: IRouter;
  children?: any;
  translate: TTranslate;
  style?: any;
  className?: string;
  user?: IUser;
  organisation?: IOrganisation;
  size?: number;
  offset?: number;
}

export interface PageState {}

class Page extends React.Component<PageProps, PageState> {
  render() {
    const { children, style, className, offset, size } = this.props;
    if (offset && size) {
      return (
        <Row className={"page " + (className || "")} style={style}>
          <Col offset={offset} sm={size}>
            {children}
          </Col>
        </Row>
      );
    }
    return (
      <div className={"page " + (className || "")} style={style}>
        {children}
      </div>
    );
  }
}

export default Page;
